import * as supabase from '@/libs/supabase'
import { definitions } from '@/types/dto'
import { PaidTrack, Room, RoomFullState, RoomFullStateDto } from '@/types/room'
import * as paidTracks from './paid-tracks'
import * as upvotes from './upvotes'

export * as tracks from './tracks'
export * as paidTracks from './paid-tracks'
export * as upvotes from './upvotes'

export const createRoom = async (publicId: string, ownerId: string) => {
  const params = { name: '', public_id: publicId, owner_id: ownerId }
  const { data, error } = await supabase.rooms().insert(params).single()
  if (error) console.error(error)
  if (!data) return
  return deserializeRoom(data)
}

export const updateRoom = (room: Partial<Room>) => {
  const params = { name: room.name, public_id: room.publicId }
  const uid = supabase.client.auth.user()?.id
  return supabase.rooms().update(params).eq('owner_id', uid)
}

export const getMyRoom = async () => {
  const uid = supabase.client.auth.user()?.id
  const { data } = await supabase.rooms().select().eq('owner_id', uid)
  if (!data || data.length === 0) return
  return deserializeRoom(data[0])
}

export type RoomCallback = (newRoom: Room) => void
export const subscribeToRoomUpdates = (roomId: number, cb: RoomCallback) => {
  return supabase
    .rooms({ id: roomId })
    .on('*', payload => cb(deserializeRoom(payload.new)))
    .subscribe()
}

export const getBy = async (options: { id?: number; slug?: string }) => {
  const selector = options.id ? 'id' : 'public_id'
  const value = options.id ?? options.slug
  if (!value) new Error('No id or slug')
  const selectRooms = `*, up_votes:up_votes(*), paid_tracks:paid_tracks(*)`
  const query = supabase.rooms().select(selectRooms).eq(selector, value)
  const data = await supabase.query(query)
  if (data.length > 0) {
    return deserializeInitialState(data[0] as RoomFullStateDto)
  }
}

export const deserializeInitialState = (
  state: RoomFullStateDto
): RoomFullState => ({
  room: deserializeRoom(state),
  paidTracks: state.paid_tracks.map(paidTracks.deserializePaidTrack),
  upVotes: state.up_votes.map(upvotes.deserializeUpVote),
})

export const deserializeRoom = (room: definitions['rooms']): Room => ({
  id: room.id,
  publicId: room.public_id ?? '',
  modifiedDate: new Date(room.modified_at as string),
  name: room.name,
  ownerId: room.owner_id,
  isSpotify: room.is_spotify,
  playing: room.playing,
})

export const getRoomPaidTracks = async (
  roomId: number
): Promise<PaidTrack[]> => {
  const { data } = await supabase.paidTracks().select().eq('room_id', roomId)
  return (data ?? []).map(track => ({
    trackId: 0, //track.track_id,
    ownerId: track.owner_id,
  }))
}

export const updatePlaying = async (roomId: number, playing?: number) => {
  if (playing) {
    await supabase.rooms().update({ playing }).eq('id', roomId)
  } else {
    const playing: any = null
    await supabase.rooms().update({ playing }).eq('id', roomId)
  }
}
